import { atomWithStorage } from "jotai/utils";

/** Local preference for users whose OS reserves the default toolbar chord. */
export const toolbarShortcutsRequireShiftAtom = atomWithStorage<boolean>(
  "toolbarShortcutsRequireShift",
  false,
);
